import { Component } from '@angular/core';

import { BaseIconComponent } from './base-icon.component';

@Component({
  selector: 'app-external-link-icon',
  template: `
    <svg
      [attr.width]="width"
      [attr.height]="height"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.5 8.33335V5.00002C17.5 4.55799 17.3244 4.13407 17.0118 3.82151C16.6993 3.50895 16.2754 3.33335 15.8333 3.33335H12.5M7.5 3.33335H4.16667C3.72464 3.33335 3.30072 3.50895 2.98816 3.82151C2.67559 4.13407 2.5 4.55799 2.5 5.00002V8.33335M2.5 11.6667V15C2.5 15.442 2.67559 15.866 2.98816 16.1785C3.30072 16.4911 3.72464 16.6667 4.16667 16.6667H7.5M12.5 16.6667H15.8333C16.2754 16.6667 16.6993 16.4911 17.0118 16.1785C17.3244 15.866 17.5 15.442 17.5 15V11.6667"
        [attr.stroke]="color"
        stroke-width="1.66667"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.33301 11.6667L14.9997 5.00002M14.9997 5.00002H11.2497M14.9997 5.00002V8.75002"
        [attr.stroke]="color"
        stroke-width="1.66667"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  `,
})
export class ExternalLinkIcon extends BaseIconComponent {}
